"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var _Util = require("../../../components/util/Util");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _userSurvey = require("../../../redux/userSurvey/userSurvey.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class SurveysLandingPage extends _react.Component {
  constructor() {
    super(...arguments);

    this.rowClassName = (record, index) => {
      return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
    };
  }

  componentDidMount() {
    this.props.getUserSurveys();
  }

  render() {
    const {
      userSurveys,
      studyId
    } = this.props;
    const columns = [{
      width: '100px',
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id
    }, {
      title: 'Survey',
      dataIndex: 'surveyName',
      key: 'surveyName',
      sorter: (a, b) => `${a.surveyName}`.localeCompare(b.surveyName),
      filters: _.map(_.sortedUniq(_.uniq(_.sortBy(_.compact(_.map(userSurveys, 'surveyName'))))), x => {
        return {
          text: x,
          value: x
        };
      }),
      defaultFilteredValue: ['HMP Stigma-3-Month FUP', 'HMP Stigma-6-Month FUP', 'HMP Stigma-9-Month FUP', 'HMP Stigma-12-Month FUP'],
      onFilter: (value, record) => record.surveyName === value
    }, {
      title: 'Username',
      dataIndex: 'participant.username',
      key: 'participant.username',
      sorter: (a, b) => a.participant && b.participant && `${a.participant.username}`.localeCompare(b.participant.username),
      filters: _.map(_.sortedUniq(_.uniq(_.sortBy(_.compact(_.map(userSurveys, 'participant.username'))))), x => {
        return {
          text: x,
          value: x
        };
      }),
      onFilter: (value, record) => record.participant.username === value,
      render: (username, userSurvey) => userSurvey.participant ? /*#__PURE__*/_react.default.createElement("a", {
        href: `/study/${studyId}/participants/${userSurvey.participant.id}`
      }, username, ' ') : /*#__PURE__*/_react.default.createElement("div", null)
    }, {
      title: 'Window Open',
      dataIndex: 'windowOpen',
      key: 'windowOpen',
      render: _Util.renderDateWithoutTime,
      sorter: (a, b) => (0, _moment.default)(a.windowOpen || 0).unix() - (0, _moment.default)(b.windowOpen || 0).unix()
    }, {
      title: 'Window Close',
      dataIndex: 'windowClose',
      key: 'windowClose',
      render: _Util.renderDateWithoutTime,
      sorter: (a, b) => (0, _moment.default)(a.windowClose || 0).unix() - (0, _moment.default)(b.windowClose || 0).unix()
    }, {
      title: 'Days Remaining',
      dataIndex: 'daysRemaining',
      key: 'daysRemaining',
      sorter: (a, b) => a.daysRemaining - b.daysRemaining,
      defaultSortOrder: 'ascend'
    }];
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: '0 0 auto',
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_table.default, {
      columns: columns,
      dataSource: userSurveys,
      scroll: {
        y: 'calc(100vh - 150px)'
      },
      pagination: false,
      rowClassName: this.rowClassName,
      rowKey: "id"
    }));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  userSurveys: selectors.getUserSurveys,
  studyId: selectors.getRequestedStudyId
});

const mapDispatchToProps = dispatch => {
  return {
    getUserSurveys: () => dispatch(_userSurvey.getUserSurveysAsync.request())
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SurveysLandingPage));

exports.default = _default;